module.exports = __webpack_public_path__ + "static/media/mapa_atuacao.b686759a.png";